// extracted by mini-css-extract-plugin
module.exports = {"HeroesCatalogue":"HeroesCatalogue__HeroesCatalogue__3ELWs"};